import React, { useState, useEffect } from 'react'
import './Document.css'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { pdfjs } from 'react-pdf'
import DocumentWindow from './DocumentWindow'
import Spinner, { SmallSpinner } from '../../utilities/spinner/Spinner'
import { embedImageAndText } from '../../utilities/fileReader/SigningHandler'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
//Bootstrap
import Button from 'react-bootstrap/Button'
//Redux
import { signDocument, clearImages, clearTextboxes, setErrors, clearErrors } from '../../redux'
import { useSelector, useDispatch } from 'react-redux'

toast.configure()
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

function DocumentPreview(props) {
  const { url, document, close } = props

  const dispatch = useDispatch()

  const image = useSelector((state) => state.image)
  const textbox = useSelector((state) => state.textbox)
  const user = useSelector((state) => state.user)
  const ui = useSelector((state) => state.ui)

  const history = useHistory()

  const [file, setFile] = useState(null)

  useEffect(() => {
    if (image.images.length > 0 || textbox.textboxes.length > 0) {
      embedImageAndText(url, image.images, textbox.textboxes)
        .then((result) => {
          setFile(result)
        })
        .catch((error) => {
          dispatch(setErrors(error))
        })
    }
  }, [image, textbox, url])

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(signDocument(document, user.credentials.id, user.credentials.name, image.images, textbox.textboxes, history))
  }

  const handleCancel = () => {
    dispatch(clearImages())
    dispatch(clearTextboxes())
    dispatch(clearErrors())

    close()
  }

  let documentPreviewMarkup = file ? (
    <div className='preview-container '>
      <div className='preview-style '>
        <DocumentWindow file={file} />
      </div>
      <div className='preview-dialog'>
        <div className='preview-button'>
          <Button variant='success' onClick={handleSubmit} className='btn-no-outline' disabled={ui.loading || ui.errors}>
            <div>Submit{ui.loading && <SmallSpinner />}</div>
          </Button>
          <Button variant='danger' onClick={handleCancel} disabled={ui.loading}>
            Cancel
          </Button>
        </div>
        <h6>Submitted document cannot be modified by you anymore.</h6>
      </div>
    </div>
  ) : (
    <Spinner />
  )

  return <div className='preview-modal '>{documentPreviewMarkup}</div>
}

DocumentPreview.propTypes = {
  url: PropTypes.string.isRequired,
  document: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
}

export default DocumentPreview
